import React from "react"
import styled from "styled-components"
import Image from "next/image"
import Heading from "@/common/components/_UI/Heading"
import Buttons from "./_UI/Buttons"
import { theme } from "@/common/Mixin"

interface BannerProps {
  title0: string
  title1: string
  title2: string
  desc: string
  btns: any
  content: any
  icon: string
  bg?: any
  themeNew: string
  white?: boolean
  bigP: boolean
  id?: string
}

const Banner = ({
  title0,
  title1,
  title2,
  desc,
  btns,
  content,
  icon,
  bg,
  themeNew,
  white,
  bigP,
  id
}: BannerProps) => {
  return (
    <SectionWrapper id={id}>
      {bg}
      <Wrapper>
        <SectionObject>{content}</SectionObject>
        <ContentWrapper>
          <TitlesWrapper className={bigP ? "bigP" : undefined}>
            <ProductTitleWrapper>
              {icon && (
                <IconWrapper>
                  <IconBox>
                    <Image
                      src={icon}
                      alt={title0}
                      fill
                      sizes="100vw"
                      style={{
                        objectFit: "cover"
                      }}
                    />
                  </IconBox>
                </IconWrapper>
              )}
              <h3>{title0}</h3>
            </ProductTitleWrapper>
            <Heading
              as="h1"
              content={title1}
              content2={title2}
              shadow
              themeNew={themeNew}
              type={white ? "white" : "primary"}
            />
            <p>{desc}</p>
          </TitlesWrapper>
          {btns && <Buttons btns={btns} />}
        </ContentWrapper>
      </Wrapper>
    </SectionWrapper>
  )
}
export default Banner

const SectionWrapper = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  max-height: 1000px;
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (${theme.lg}) {
    min-height: 100vh;
    max-height: 2000px;
    height: auto;
    align-items: start;
  }
  @media (max-width: 640px) {
  }
`
const Wrapper = styled.section`
  max-width: 1400px;
  gap: 24px;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  width: 100%;
  padding: 30px var(--paddingX) 0px var(--paddingX);
  align-items: center;

  @media only screen and (${theme.lg}) {
    display: flex;
    max-height: auto;
    flex-direction: column;
    min-height: 100vh;
    height: auto;
    justify-content: center;
    padding: 60px var(--paddingX) 0px var(--paddingX);
  }
  @media (${theme.lg}) {
    padding: 60px 0 100px 0;
  }
`

const SectionObject = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  order: 2;
  width: 100%;

  transform: translate(60px, 0px);

  @media (${theme.lg}) {
    transform: translate(0px, 0px);
    order: 0;
    width: clamp(300px, 100%, 700px);
    position: relative;
    height: auto;
    top: auto;
    left: auto;
    img {
      margin-bottom: 30px;
    }
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: visible;
  padding: 30px 0px;
  align-items: start;
  justify-content: center;
  h1 {
    margin-left: -4px;
  }
  @media (${theme.md}) {
    text-align: center;
    padding: 0px var(--paddingX) 0px var(--paddingX);
    max-width: 500px;
    align-items: center;
    h1 {
      margin-left: 0px;
    }
  }
`

const ProductTitleWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
  @media (${theme.lg}) {
    width: 100%;
    margin-left: -12px;
    align-items: center;
    justify-content: center;
  }
`
const IconWrapper = styled.div`
  width: 48px;
  @media (${theme.lg}) {
    width: 32px;
  }
`
const IconBox = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
`
const TitlesWrapper = styled.div`
  width: 100%;
  @media (${theme.lg}) {
    margin: 0 auto;
  }
  h1 {
    display: flex;
    flex-wrap: wrap;
    @media (${theme.lg}) {
      span {
        width: 100%;
      }
      justify-content: center;
      text-align: center;
    }
  }
  p {
    margin-top: 24px;
    @media (${theme.lg}) {
      text-align: center;
      max-width: 600px;
      margin: 8px auto 0 auto;
    }
  }
  &.bigP {
    p {
      font-size: var(--h3);
      color: #fff;
    }
  }
`
